var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { classMap, Component, CustomElement, Event, html, Prop, State, Watch } from '@sick-davinci/ce-decorators';
import { style } from './DrawerNavigationItem.style';
import { IconRef } from '@sick-davinci/basic-elements/lib/icon/IconRef';
import { icon_expand_more as expandIcon } from '@sick-davinci/material-icons/navigation/expand_more.icon';
import { icon_description as defaultIcon } from '@sick-davinci/material-icons/action/description.icon';
import { icon_expand_less as closeIcon } from '@sick-davinci/material-icons/navigation/expand_less.icon';

/**
 * A `davinci-core-drawer-navigation-item` is an item of a `davinci-core-drawer-navigation`, which handles navigation
 *
 * @example
 * ```html
 *  <davinci-core-drawer-navigation>
 *    <davinci-core-drawer-navigation-item
 *      icon="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'
 *        viewBox='0 0 24 24'%3E%3Cpath d='M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z'/%3E%3C/svg%3E"
 *      label="fast rewind icon"
 *      route="/navigate/back"
 *    >Forward</davinci-core-drawer-navigation-item>
 *  </davinci-core-drawer-navigation>
 * ```
 */
export let DrawerNavigationItem = (_dec = Component({
  style: [style],
  tag: 'davinci-core-drawer-navigation-item',
  dependencies: [IconRef]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop({
  type: String
}), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop({
  type: Boolean
}), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop({
  type: Boolean
}), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Event('navigate'), _dec15 = Reflect.metadata("design:type", Object), _dec16 = State(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = State(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = State(), _dec21 = Reflect.metadata("design:type", Number), _dec22 = State(), _dec23 = Reflect.metadata("design:type", Boolean), _dec24 = State(), _dec25 = Reflect.metadata("design:type", Boolean), _dec26 = Watch('nestLevel'), _dec27 = Reflect.metadata("design:paramtypes", [Number, Number]), _dec28 = Watch('drawerExpanded'), _dec29 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec30 = Watch('flyoutMode'), _dec31 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec32 = Watch('expanded'), _dec33 = Reflect.metadata("design:paramtypes", []), _dec34 = Watch('flyoutExpanded'), _dec35 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class DrawerNavigationItem extends CustomElement {
  constructor(...args) {
    super(...args);
    /**
     * Specifies the text to be displayed in the item
     * Example: label="Home"
     */
    _initializerDefineProperty(this, "label", _descriptor, this);
    /**
     * Specifies the route that is emitted when the item is clicked
     * Example: route="/account/profile"
     */
    _initializerDefineProperty(this, "route", _descriptor2, this);
    /**
     * Specifies the icon as dataurl (base64 or url encoded svg string).
     * It is applied to first-level items only!
     *
     * Example:
     * src="data:image/svg+xml;base64,..." or
     * src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='...'/%3E%3C/svg%3E"
     */
    _initializerDefineProperty(this, "icon", _descriptor3, this);
    /**
     * If true, the item will be highlighted as active
     */
    _initializerDefineProperty(this, "active", _descriptor4, this);
    /**
     * If true, the item will render grayed out and no navigate-event will be fired on click.
     */
    _initializerDefineProperty(this, "disabled", _descriptor5, this);
    /**
     * If true, the item shows the subsequent drawer-navigation-items / children
     */
    _initializerDefineProperty(this, "expanded", _descriptor6, this);
    /**
     * Emits the route when the item is clicked.
     */
    _initializerDefineProperty(this, "navigateEvent", _descriptor7, this);
    _initializerDefineProperty(this, "flyoutExpanded", _descriptor8, this);
    _initializerDefineProperty(this, "flyoutMode", _descriptor9, this);
    _initializerDefineProperty(this, "nestLevel", _descriptor10, this);
    _initializerDefineProperty(this, "drawerExpanded", _descriptor11, this);
    _initializerDefineProperty(this, "isParent", _descriptor12, this);
    _defineProperty(this, "standardFontSize", 14);
    _defineProperty(this, "_onPointerIn", event => {
      if (event.pointerType === 'mouse' && this.flyoutMode && !this.disabled) {
        this.flyoutExpanded = this.isParent;
        event.target.classList.add('hover');
      }
    });
    _defineProperty(this, "_onPointerOut", event => {
      if (event.pointerType === 'mouse' && this.flyoutMode && !this.disabled) {
        this.flyoutExpanded = false;
        event.target.classList.remove('hover');
      }
    });
    _defineProperty(this, "_scrollHandler", () => {
      if (this.flyoutMode && this.flyoutExpanded) {
        this._updateFlyoutVisibility();
      }
    });
    _defineProperty(this, "bodyClickHandler", () => {
      if (this.flyoutMode) {
        this.flyoutExpanded = false;
      }
    });
  }
  onNestLevelChange(_o, _nestLevel) {
    this._setChildrenNestLevel();
  }
  onDrawerExpandedChange(_o, expanded) {
    if (expanded) {
      this.classList.add('drawer-expanded');
    } else {
      this.classList.remove('drawer-expanded');
    }
  }
  onFlyoutModeChange(_o, flyoutMode) {
    if (flyoutMode) {
      this.classList.add('flyout');
    } else {
      this.classList.remove('flyout');
    }
    this.scheduleRender(true);
  }
  onExpandedChange() {
    if (this.expanded && this.isParent) {
      this.classList.add('expanded');
      this._addScrollEventListenersToParentNodes();
    } else {
      this.classList.remove('expanded');
      this._removeScrollEventListenerFromParentNodes();
    }
  }
  onFlyoutExpandedChange() {
    if (this.flyoutExpanded && this.isParent) {
      this.classList.add('expanded');
      this._addScrollEventListenersToParentNodes();
    } else {
      this.classList.remove('expanded');
      this._removeScrollEventListenerFromParentNodes();
    }
    this._updateFlyoutVisibility();
    this._handleExternalTapOnTouchDevice();
  }
  componentConnected() {
    this.isRoot = this.parentElement.tagName.toLocaleLowerCase() === 'davinci-core-drawer-navigation';
    if (this.isRoot) {
      this.classList.add('root');
    } else {
      this.classList.remove('root');
    }
    if (this.isRoot) {
      this.addEventListener('pointerenter', this._onPointerIn);
      this.addEventListener('pointerleave', this._onPointerOut);
    }
  }
  componentDisconnected() {
    if (this.isRoot) {
      this.removeEventListener('pointerenter', this._onPointerIn);
      this.removeEventListener('pointerleave', this._onPointerOut);
    }
  }
  componentFirstRender() {
    this._observeFlyoutSize();
  }
  componentWillRender() {
    if (this.isRoot) {
      if (!this.icon) {
        this.icon = defaultIcon;
      }
      this.classList.add('icon');
    }
  }
  componentDidRender() {
    this.childrenEl = this.shadowRoot.querySelector('.children');
  }
  render() {
    const linkWrapperClasses = {
      'link-wrapper': true,
      nested: !!this.nestLevel
    };
    if (this.nestLevel) {
      linkWrapperClasses['level-' + this.nestLevel] = true;
    }
    const showToggle = this.isParent && !this.flyoutMode;
    return html`
      <div class="${classMap(linkWrapperClasses)}" @click="${this._onLinkClick}">
        <div class="${classMap({
      link: true,
      hasToggle: showToggle
    })}">
          ${this.renderIcon()}
          ${this.flyoutMode ? html`` : html`<span class="text">${this.label}</span>`}
        </div>
        ${showToggle ? html`<davinci-icon-ref class="toggle" src="${this.expanded ? closeIcon : expandIcon}"></davinci-icon-ref>` : html``}
      </div>
      <div class="${classMap({
      children: true,
      expanded: this.expanded
    })}">
        <div class="flyout-wrapper">
          ${this.flyoutMode ? html`
            <div class="header">
              <span class="text">${this.label}</span>
            </div>
          ` : html``}
          <slot @slotchange="${this._onSlotChanged}"></slot>
        </div>
      </div>
    `;
  }
  renderIcon() {
    if (this.isRoot) {
      return html`
        <div class="icon-box">
          <davinci-icon-ref class="icon" src="${this.icon}"></davinci-icon-ref>
        </div>
      `;
    }
    return html``;
  }
  _onLinkClick(e) {
    if (!this.isParent) {
      this._emit();
    } else {
      e.stopPropagation();
    }
    this._toggleExpansion();
  }
  _toggleExpansion() {
    if (!this.disabled) {
      this.expanded = !this.expanded;
      this.flyoutExpanded = !this.flyoutExpanded;
    }
  }
  _setChildrenNestLevel() {
    Array.from(this.children).forEach(item => {
      item.nestLevel = this.nestLevel + 1;
    });
  }
  _emit() {
    if (!this.disabled) {
      this.navigateEvent.emit(this.route);
    }
  }
  _updateFlyoutVisibility() {
    if (this.isParent && this.flyoutMode && !this.disabled) {
      this.flyoutExpanded ? this._updateVisibleFlyoutPosition() : this._resetFlyoutHidden();
    } else {
      this._resetFlyoutHidden();
    }
  }
  _updateVisibleFlyoutPosition() {
    const baseFontSize = parseInt(window.getComputedStyle(document.querySelector(':root'), null).getPropertyValue('font-size'), 10);
    const scaleFactor = baseFontSize / this.standardFontSize;
    window.cancelAnimationFrame(this.animationRequestId);
    this.animationRequestId = window.requestAnimationFrame(() => {
      const itemClientRect = this.getBoundingClientRect();
      const childrenClientRect = this.childrenEl.getBoundingClientRect();
      const childrenHeight = childrenClientRect.height;
      const bottomSpace = window.innerHeight - itemClientRect.top;
      const bottomTooTight = childrenHeight > bottomSpace;
      const iosOffset = this._getIosScrollOffset();
      this.childrenEl.style.left = this.parentElement.getBoundingClientRect().right - 10 * scaleFactor - iosOffset.x + 'px';
      if (bottomTooTight && itemClientRect.top > bottomSpace) {
        // expand upwards
        this.childrenEl.classList.add('upwards');
        this.childrenEl.style.top = itemClientRect.bottom - childrenClientRect.height - iosOffset.y + 'px';
      } else {
        // expand downwards
        this.childrenEl.classList.remove('upwards');
        this.childrenEl.style.top = itemClientRect.top - iosOffset.y + 'px';
      }
    });
  }
  _resetFlyoutHidden() {
    if (!this.childrenEl) {
      return;
    }
    window.cancelAnimationFrame(this.animationRequestId);
    this.animationRequestId = window.requestAnimationFrame(() => {
      this.childrenEl.style.bottom = '';
      this.childrenEl.style.left = '';
      this.childrenEl.style.top = '';
      this.childrenEl.classList.remove('upwards');
    });
  }
  _getIosScrollOffset() {
    const el = document.createElement('div');
    document.body.appendChild(el);
    el.style.cssText = 'position: fixed; width: 0; height: 0; top: 0; left: 0';
    const {
      left,
      top
    } = el.getBoundingClientRect();
    document.body.removeChild(el);
    return {
      x: left,
      y: top
    };
  }
  _onSlotChanged() {
    this.isParent = this.children.length > 0;
    this._setChildrenNestLevel();
  }

  /**
   * recursively add scrollEvent-Listeners in order to update
   * flyout-position on scroll
   */
  _addScrollEventListenersToParentNodes() {
    if (this.isParent && this.flyoutMode && !this.disabled) {
      let node = this.parentNode;
      while (node) {
        node.addEventListener('scroll', this._scrollHandler);
        node = node.parentNode;
      }
    }
  }
  _removeScrollEventListenerFromParentNodes() {
    if (this.isParent && this.flyoutMode) {
      let node = this.parentNode;
      while (node) {
        node.removeEventListener('scroll', this._scrollHandler);
        node = node.parentNode;
      }
    }
  }
  _observeFlyoutSize() {
    new ResizeObserver(() => this._updateFlyoutVisibility()).observe(this.shadowRoot.querySelector('.flyout-wrapper'));
  }
  /**
   * Closes children-flyout on touch-devices, when user taps outside the item component / drawer-navigation component.
   */
  _handleExternalTapOnTouchDevice() {
    requestAnimationFrame(() => {
      // defer until opening event bubbled
      if (this.children.length && this.flyoutMode && this.flyoutExpanded) {
        document.body.addEventListener('click', this.bodyClickHandler);
      } else {
        document.body.removeEventListener('click', this.bodyClickHandler);
      }
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "route", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "active", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "expanded", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "navigateEvent", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "flyoutExpanded", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "flyoutMode", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "nestLevel", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -1;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "drawerExpanded", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "isParent", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onNestLevelChange", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "onNestLevelChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onDrawerExpandedChange", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "onDrawerExpandedChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onFlyoutModeChange", [_dec30, _dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "onFlyoutModeChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onExpandedChange", [_dec32, _dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "onExpandedChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onFlyoutExpandedChange", [_dec34, _dec35], Object.getOwnPropertyDescriptor(_class2.prototype, "onFlyoutExpandedChange"), _class2.prototype)), _class2)) || _class);
